import { apiRequest } from "./client";
import type { PublishedDefinition } from "../types";

export interface ShareLink {
  id: string;
  report_id: string;
  label: string;
  token_prefix: string;
  state: "active" | "expired" | "revoked";
  created_by: string;
  created_by_name: string | null;
  created_at: string;
  expires_at: string | null;
  revoked_at: string | null;
  last_used_at: string | null;
  open_count: number;
}

/** Returned once, at creation -- the full link can't be shown again. */
export interface CreatedShareLink extends ShareLink {
  token: string;
  path: string;
}

export const shareLinksApi = (base: "/admin" | "/owner") => {
  const root = (reportId: string) => `/api/v1${base}/reports/${reportId}/share-links`;
  return {
    list: (reportId: string) => apiRequest<ShareLink[]>(root(reportId)),
    create: (reportId: string, body: { label: string; expires_in_days: number | null }) =>
      apiRequest<CreatedShareLink>(root(reportId), { method: "POST", body }),
    revoke: (reportId: string, linkId: string) =>
      apiRequest<ShareLink>(`${root(reportId)}/${linkId}/revoke`, { method: "POST" }),
  };
};

/** Public: what a share link opens (no sign-in). */
export const getSharedPublished = (token: string) =>
  apiRequest<PublishedDefinition>(`/api/v1/share/${encodeURIComponent(token)}/published`);

export const shareUrl = (path: string) => `${window.location.origin}${path}`;
